import "core-js/modules/es.array.map";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { vipCallRecharge } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage, serchSelect, tabulation } from "@/mixins/index";
export default {
  name: "vipWeekRecharge",
  mixins: [gmToolNew, gmToolNewPage, serchSelect, tabulation],
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      exportLoading: false,
      paramsData: {
        week: "",
        user_id: "",
        user_name: ""
      },
      date: [],
      total: 0,
      weekData: "",
      startWeek: [{
        id: 1,
        value: 1
      }, {
        id: 2,
        value: 2
      }, {
        id: 3,
        value: 3
      }, {
        id: 4,
        value: 4
      }, {
        id: 5,
        value: 5
      }],
      dataToTal: 0,
      sumAmount: 0,
      proportion: '0',
      value2: []
    };
  },
  created: function created() {},
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!((!_this.weekData || !_this.paramsData.week) && !_this.value2.length)) {
                  _context2.next = 3;
                  break;
                }

                _this.$message.error(_this.$t('pleaseSelectYearMonthOrWeekOrDateRange'));

                return _context2.abrupt("return");

              case 3:
                _this.reqLoading = true;
                params = {
                  env_id: _this.paramsData.env_id,
                  game_id: _this.rawData.game_id,
                  server_id: _this.paramsData.server_id,
                  currency_info: _this.defaultData().currency_info,
                  user_id: _this.paramsData.user_id,
                  user_name: _this.paramsData.user_name
                };

                if (_this.value2.length) {
                  params.startTime = _this.value2[0];
                  params.endTime = _this.value2[1];
                } else {
                  params.week = _this.paramsData.week;
                  params.year = _this.weekData.substring(0, 4);
                  params.month = _this.weekData.substring(5, 7);
                }

                vipCallRecharge(params).then(function (res) {
                  if (res.status == 200) {
                    _this.dataToTal = _this.isyjfmvnd() ? res.data.total : _this.$utils.conversion(res.data.total).toFixed(2);
                    _this.sumAmount = _this.isyjfmvnd() ? res.data.sumAmount : _this.$utils.conversion(res.data.sumAmount).toFixed(2);
                    _this.proportion = res.data.proportion;
                    res.data.data.map(function (i) {
                      i.real_time_amount = _this.isyjfmvnd() ? i.real_time_amount : _this.$utils.conversion(i.real_time_amount).toFixed(2);
                    });
                    res.data.data.push({
                      user_id: _this.$t('total'),
                      server_id: "/",
                      user_name: "/",
                      vip_class: "/",
                      real_time_amount: _this.isyjfmvnd() ? res.data.total : _this.$utils.conversion(res.data.total).toFixed(2),
                      last_login_time: "/",
                      last_recharge_time: "/"
                    });
                    _this.tableData = res.data.data;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    exportdata: function exportdata() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  env_id: _this2.paramsData.env_id,
                  game_id: _this2.rawData.game_id,
                  server_id: _this2.paramsData.server_id,
                  currency_info: _this2.defaultData().currency_info,
                  user_id: _this2.paramsData.user_id,
                  user_name: _this2.paramsData.user_name
                };

                if (_this2.value2.length) {
                  params.startTime = _this2.value2[0];
                  params.endTime = _this2.value2[1];
                } else {
                  params.week = _this2.paramsData.week;
                  params.year = _this2.weekData.substring(0, 4);
                  params.month = _this2.weekData.substring(5, 7);
                }

                vipCallRecharge(params).then(function (res) {
                  if (res.status == 200) {
                    var columns = [{
                      label: _this2.$t('userId'),
                      prop: 'user_id'
                    }, {
                      label: _this2.$t('serverId'),
                      prop: 'server_id'
                    }, {
                      label: _this2.$t('userName'),
                      prop: 'user_name'
                    }, {
                      label: _this2.$t('vipLevel'),
                      prop: 'vip_class'
                    }, {
                      label: _this2.$t('weekRechargeTotal'),
                      prop: 'real_time_amount'
                    }, {
                      label: _this2.$t('weekRechargeProportion'),
                      prop: 'proportion'
                    }, {
                      label: _this2.$t('lastLoginTime'),
                      prop: 'last_login_time'
                    }, {
                      label: _this2.$t('lastRechargeTime'),
                      prop: 'last_recharge_time'
                    }];
                    res.data.data.map(function (i) {
                      i.real_time_amount = _this2.isyjfmvnd() ? i.real_time_amount : _this2.$utils.conversion(i.real_time_amount).toFixed(2);
                    });
                    res.data.data.push({
                      user_id: _this2.$t('total'),
                      server_id: "/",
                      user_name: "/",
                      vip_class: "/",
                      real_time_amount: _this2.isyjfmvnd() ? res.data.total : _this2.$utils.conversion(res.data.total).toFixed(2),
                      last_login_time: "/",
                      last_recharge_time: "/"
                    });

                    _this2.$export.excel({
                      columns: columns,
                      data: res.data.data,
                      title: _this2.$route.meta.title
                    });
                  }
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};